import Icon from 'common/Icon'
import Modal from 'common/Modal'
import { DIM_GREY } from 'constants/colors'
import './index.scss'
import { stateAbbreviations } from 'app/SeFriendly/validateUsaState'
import { RESTRICTED_STIMULANT_STATES } from 'app/Bookings/constants'
import { useRouter } from 'next/router'

type LocationFilterProps = {
  showModal: boolean
  onHide: () => void
}

const PsychNoticeModal: React.FC<LocationFilterProps> = ({
  showModal,
  onHide,
}) => {
  const router = useRouter()
  const { query } = router

  const currentState = query?.state as string

  const fullStateName = stateAbbreviations[currentState]

  const restrictedStatesNames = RESTRICTED_STIMULANT_STATES.map(
    (state) => stateAbbreviations[state]
  )

  const restrictedStatesInSentence =
    restrictedStatesNames.slice(0, -1).join(', ') +
    ' and ' +
    restrictedStatesNames.slice(-1)

  return (
    <Modal
      show={showModal}
      onHide={onHide}
      size="md"
      modalType="centered-content-no-overflow"
      contentClassOverride="PsychNoticeModal"
    >
      <div className="PsychNoticeModal__container">
        <div>
          <div className="PsychNoticeModal__title">
            Psychiatry Stimulants Notice
          </div>

          <div className="PsychNoticeModal__text">
            It looks like you’re trying to schedule an appointment for ADHD in{' '}
            <b>{fullStateName}</b>.
            <br />
            <br />
            Please remember that for a Psychiatry appointment state regulations
            prevent online prescribing of stimulant medication in{' '}
            {restrictedStatesInSentence}.
          </div>
        </div>

        <button className="PsychNoticeModal__closeIconBtn" onClick={onHide}>
          <Icon icon="lightCross" className="fa-md" fill={DIM_GREY} />
        </button>
      </div>
    </Modal>
  )
}

export default PsychNoticeModal
